import { useMemo } from 'react';

const useSimpleId = () => useMemo(() => parseInt(Math.random() * 100000).toString(), []);

export default useSimpleId